// extracted by mini-css-extract-plugin
module.exports = {"mdNote":"ModalNotes_mdNote__1bHag","modalFooterButton":"ModalNotes_modalFooterButton__3bRWC"};